module.exports = __webpack_public_path__ + "img/banner.0478d1e2.png";